import { i as e, r as t, t as n } from "./dist-CwLHbU0Z.js";
import * as r from "zod";
import { ZodError as i } from "zod";
//#region src/generated/core/bodySerializer.gen.ts
var a = { bodySerializer: (e) => JSON.stringify(e, (e, t) => typeof t == "bigint" ? t.toString() : t) };
Object.entries({
	$body_: "body",
	$headers_: "headers",
	$path_: "path",
	$query_: "query"
});
//#endregion
//#region src/generated/core/serverSentEvents.gen.ts
var o = ({ onRequest: e, onSseError: t, onSseEvent: n, responseTransformer: r, responseValidator: i, sseDefaultRetryDelay: a, sseMaxRetryAttempts: o, sseMaxRetryDelay: s, sseSleepFn: c, url: l, ...u }) => {
	let d, f = c ?? ((e) => new Promise((t) => setTimeout(t, e)));
	return { stream: async function* () {
		let c = a ?? 3e3, p = 0, m = u.signal ?? new AbortController().signal;
		for (; !m.aborted;) {
			p++;
			let a = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
			d !== void 0 && a.set("Last-Event-ID", d);
			try {
				let t = {
					redirect: "follow",
					...u,
					body: u.serializedBody,
					headers: a,
					signal: m
				}, o = new Request(l, t);
				e && (o = await e(l, t));
				let s = await (u.fetch ?? globalThis.fetch)(o);
				if (!s.ok) throw Error(`SSE failed: ${s.status} ${s.statusText}`);
				if (!s.body) throw Error("No body in SSE response");
				let f = s.body.pipeThrough(new TextDecoderStream()).getReader(), p = "", h = () => {
					try {
						f.cancel();
					} catch {}
				};
				m.addEventListener("abort", h);
				try {
					for (;;) {
						let { done: e, value: t } = await f.read();
						if (e) break;
						p += t, p = p.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
						let a = p.split("\n\n");
						p = a.pop() ?? "";
						for (let e of a) {
							let t = e.split("\n"), a = [], o;
							for (let e of t) if (e.startsWith("data:")) a.push(e.replace(/^data:\s*/, ""));
							else if (e.startsWith("event:")) o = e.replace(/^event:\s*/, "");
							else if (e.startsWith("id:")) d = e.replace(/^id:\s*/, "");
							else if (e.startsWith("retry:")) {
								let t = Number.parseInt(e.replace(/^retry:\s*/, ""), 10);
								Number.isNaN(t) || (c = t);
							}
							let s, l = !1;
							if (a.length) {
								let e = a.join("\n");
								try {
									s = JSON.parse(e), l = !0;
								} catch {
									s = e;
								}
							}
							l && (i && await i(s), r && (s = await r(s))), n?.({
								data: s,
								event: o,
								id: d,
								retry: c
							}), a.length && (yield s);
						}
					}
				} finally {
					m.removeEventListener("abort", h), f.releaseLock();
				}
				break;
			} catch (e) {
				if (t?.(e), o !== void 0 && p >= o) break;
				let n = Math.min(c * 2 ** (p - 1), s ?? 3e4);
				await f(n);
			}
		}
	}() };
}, s = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, c = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, l = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, u = ({ allowReserved: e, explode: t, name: n, style: r, value: i }) => {
	if (!t) {
		let t = (e ? i : i.map((e) => encodeURIComponent(e))).join(c(r));
		switch (r) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let a = s(r), o = i.map((t) => r === "label" || r === "simple" ? e ? t : encodeURIComponent(t) : d({
		allowReserved: e,
		name: n,
		value: t
	})).join(a);
	return r === "label" || r === "matrix" ? a + o : o;
}, d = ({ allowReserved: e, name: t, value: n }) => {
	if (n == null) return "";
	if (typeof n == "object") throw Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
	return `${t}=${e ? n : encodeURIComponent(n)}`;
}, f = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: a }) => {
	if (i instanceof Date) return a ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let o = l(r), s = Object.entries(i).map(([t, i]) => d({
		allowReserved: e,
		name: r === "deepObject" ? `${n}[${t}]` : t,
		value: i
	})).join(o);
	return r === "label" || r === "matrix" ? o + s : s;
}, p = /\{[^{}]+\}/g, m = ({ path: e, url: t }) => {
	let n = t, r = t.match(p);
	if (r) for (let t of r) {
		let r = !1, i = t.substring(1, t.length - 1), a = "simple";
		i.endsWith("*") && (r = !0, i = i.substring(0, i.length - 1)), i.startsWith(".") ? (i = i.substring(1), a = "label") : i.startsWith(";") && (i = i.substring(1), a = "matrix");
		let o = e[i];
		if (o == null) continue;
		if (Array.isArray(o)) {
			n = n.replace(t, u({
				explode: r,
				name: i,
				style: a,
				value: o
			}));
			continue;
		}
		if (typeof o == "object") {
			n = n.replace(t, f({
				explode: r,
				name: i,
				style: a,
				value: o,
				valueOnly: !0
			}));
			continue;
		}
		if (a === "matrix") {
			n = n.replace(t, `;${d({
				name: i,
				value: o
			})}`);
			continue;
		}
		let s = encodeURIComponent(a === "label" ? `.${o}` : o);
		n = n.replace(t, s);
	}
	return n;
}, h = ({ baseUrl: e, path: t, query: n, querySerializer: r, url: i }) => {
	let a = i.startsWith("/") ? i : `/${i}`, o = (e ?? "") + a;
	t && (o = m({
		path: t,
		url: o
	}));
	let s = n ? r(n) : "";
	return s.startsWith("?") && (s = s.substring(1)), s && (o += `?${s}`), o;
};
function g(e) {
	let t = e.body !== void 0;
	if (t && e.bodySerializer) return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body === "" ? null : e.body;
	if (t) return e.body;
}
//#endregion
//#region src/generated/core/auth.gen.ts
var ee = async (e, t) => {
	let n = typeof t == "function" ? await t(e) : t;
	if (n) return e.scheme === "bearer" ? `Bearer ${n}` : e.scheme === "basic" ? `Basic ${btoa(n)}` : n;
}, _ = ({ parameters: e = {}, ...t } = {}) => (n) => {
	let r = [];
	if (n && typeof n == "object") for (let i in n) {
		let a = n[i];
		if (a == null) continue;
		let o = e[i] || t;
		if (Array.isArray(a)) {
			let e = u({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "form",
				value: a,
				...o.array
			});
			e && r.push(e);
		} else if (typeof a == "object") {
			let e = f({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "deepObject",
				value: a,
				...o.object
			});
			e && r.push(e);
		} else {
			let e = d({
				allowReserved: o.allowReserved,
				name: i,
				value: a
			});
			e && r.push(e);
		}
	}
	return r.join("&");
}, te = (e) => {
	if (!e) return "stream";
	let t = e.split(";")[0]?.trim();
	if (t) {
		if (t.startsWith("application/json") || t.endsWith("+json")) return "json";
		if (t === "multipart/form-data") return "formData";
		if ([
			"application/",
			"audio/",
			"image/",
			"video/"
		].some((e) => t.startsWith(e))) return "blob";
		if (t.startsWith("text/")) return "text";
	}
}, ne = (e, t) => t ? !!(e.headers.has(t) || e.query?.[t] || e.headers.get("Cookie")?.includes(`${t}=`)) : !1, re = async ({ security: e, ...t }) => {
	for (let n of e) {
		if (ne(t, n.name)) continue;
		let e = await ee(n, t.auth);
		if (!e) continue;
		let r = n.name ?? "Authorization";
		switch (n.in) {
			case "query":
				t.query ||= {}, t.query[r] = e;
				break;
			case "cookie":
				t.headers.append("Cookie", `${r}=${e}`);
				break;
			default: t.headers.set(r, e);
		}
	}
}, v = (e) => h({
	baseUrl: e.baseUrl,
	path: e.path,
	query: e.query,
	querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : _(e.querySerializer),
	url: e.url
}), y = (e, t) => {
	let n = {
		...e,
		...t
	};
	return n.baseUrl?.endsWith("/") && (n.baseUrl = n.baseUrl.substring(0, n.baseUrl.length - 1)), n.headers = b(e.headers, t.headers), n;
}, ie = (e) => {
	let t = [];
	return e.forEach((e, n) => {
		t.push([n, e]);
	}), t;
}, b = (...e) => {
	let t = new Headers();
	for (let n of e) {
		if (!n) continue;
		let e = n instanceof Headers ? ie(n) : Object.entries(n);
		for (let [n, r] of e) if (r === null) t.delete(n);
		else if (Array.isArray(r)) for (let e of r) t.append(n, e);
		else r !== void 0 && t.set(n, typeof r == "object" ? JSON.stringify(r) : r);
	}
	return t;
}, x = class {
	fns = [];
	clear() {
		this.fns = [];
	}
	eject(e) {
		let t = this.getInterceptorIndex(e);
		this.fns[t] && (this.fns[t] = null);
	}
	exists(e) {
		let t = this.getInterceptorIndex(e);
		return !!this.fns[t];
	}
	getInterceptorIndex(e) {
		return typeof e == "number" ? this.fns[e] ? e : -1 : this.fns.indexOf(e);
	}
	update(e, t) {
		let n = this.getInterceptorIndex(e);
		return this.fns[n] ? (this.fns[n] = t, e) : !1;
	}
	use(e) {
		return this.fns.push(e), this.fns.length - 1;
	}
}, ae = () => ({
	error: new x(),
	request: new x(),
	response: new x()
}), oe = _({
	allowReserved: !1,
	array: {
		explode: !0,
		style: "form"
	},
	object: {
		explode: !0,
		style: "deepObject"
	}
}), se = { "Content-Type": "application/json" }, S = (e = {}) => ({
	...a,
	headers: se,
	parseAs: "auto",
	querySerializer: oe,
	...e
}), C = ((e = {}) => {
	let t = y(S(), e), n = () => ({ ...t }), r = (e) => (t = y(t, e), n()), i = ae(), a = async (e) => {
		let n = {
			...t,
			...e,
			fetch: e.fetch ?? t.fetch ?? globalThis.fetch,
			headers: b(t.headers, e.headers),
			serializedBody: void 0
		};
		return n.security && await re({
			...n,
			security: n.security
		}), n.requestValidator && await n.requestValidator(n), n.body !== void 0 && n.bodySerializer && (n.serializedBody = n.bodySerializer(n.body)), (n.body === void 0 || n.serializedBody === "") && n.headers.delete("Content-Type"), {
			opts: n,
			url: v(n)
		};
	}, s = async (e) => {
		let { opts: t, url: n } = await a(e), r = {
			redirect: "follow",
			...t,
			body: g(t)
		}, o = new Request(n, r);
		for (let e of i.request.fns) e && (o = await e(o, t));
		let s = t.fetch, c;
		try {
			c = await s(o);
		} catch (e) {
			let n = e;
			for (let r of i.error.fns) r && (n = await r(e, void 0, o, t));
			if (n ||= {}, t.throwOnError) throw n;
			return t.responseStyle === "data" ? void 0 : {
				error: n,
				request: o,
				response: void 0
			};
		}
		for (let e of i.response.fns) e && (c = await e(c, o, t));
		let l = {
			request: o,
			response: c
		};
		if (c.ok) {
			let e = (t.parseAs === "auto" ? te(c.headers.get("Content-Type")) : t.parseAs) ?? "json";
			if (c.status === 204 || c.headers.get("Content-Length") === "0") {
				let n;
				switch (e) {
					case "arrayBuffer":
					case "blob":
					case "text":
						n = await c[e]();
						break;
					case "formData":
						n = new FormData();
						break;
					case "stream":
						n = c.body;
						break;
					default: n = {};
				}
				return t.responseStyle === "data" ? n : {
					data: n,
					...l
				};
			}
			let n;
			switch (e) {
				case "arrayBuffer":
				case "blob":
				case "formData":
				case "text":
					n = await c[e]();
					break;
				case "json": {
					let e = await c.text();
					n = e ? JSON.parse(e) : {};
					break;
				}
				case "stream": return t.responseStyle === "data" ? c.body : {
					data: c.body,
					...l
				};
			}
			return e === "json" && (t.responseValidator && await t.responseValidator(n), t.responseTransformer && (n = await t.responseTransformer(n))), t.responseStyle === "data" ? n : {
				data: n,
				...l
			};
		}
		let u = await c.text(), d;
		try {
			d = JSON.parse(u);
		} catch {}
		let f = d ?? u, p = f;
		for (let e of i.error.fns) e && (p = await e(f, c, o, t));
		if (p ||= {}, t.throwOnError) throw p;
		return t.responseStyle === "data" ? void 0 : {
			error: p,
			...l
		};
	}, c = (e) => (t) => s({
		...t,
		method: e
	}), l = (e) => async (t) => {
		let { opts: n, url: r } = await a(t);
		return o({
			...n,
			body: n.body,
			headers: n.headers,
			method: e,
			onRequest: async (e, t) => {
				let r = new Request(e, t);
				for (let e of i.request.fns) e && (r = await e(r, n));
				return r;
			},
			serializedBody: g(n),
			url: r
		});
	};
	return {
		buildUrl: (e) => v({
			...t,
			...e
		}),
		connect: c("CONNECT"),
		delete: c("DELETE"),
		get: c("GET"),
		getConfig: n,
		head: c("HEAD"),
		interceptors: i,
		options: c("OPTIONS"),
		patch: c("PATCH"),
		post: c("POST"),
		put: c("PUT"),
		request: s,
		setConfig: r,
		sse: {
			connect: l("CONNECT"),
			delete: l("DELETE"),
			get: l("GET"),
			head: l("HEAD"),
			options: l("OPTIONS"),
			patch: l("PATCH"),
			post: l("POST"),
			put: l("PUT"),
			trace: l("TRACE")
		},
		trace: c("TRACE")
	};
})(S({
	baseUrl: "https://generic.ecommerce.api.myparcel.nl",
	throwOnError: !0
})), w = r.object({
	city: r.string().min(1).max(100).register(r.globalRegistry, { description: "The city of the address." }),
	countryCode: r.string().length(2).regex(/[A-Z]{2}/).register(r.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }),
	street: r.string().min(1).max(100).register(r.globalRegistry, { description: "The street of the address." }),
	additionalInformation: r.string().min(1).max(100).register(r.globalRegistry, { description: "Additional information about the address." }).optional(),
	boxNumber: r.string().min(1).max(20).register(r.globalRegistry, { description: "The box number of the address, only applicable for specific country codes." }).optional(),
	houseNumber: r.string().min(1).max(25).register(r.globalRegistry, { description: "The house number of the address." }).optional(),
	houseNumberSuffix: r.string().min(1).max(25).register(r.globalRegistry, { description: "The house number suffix of the address." }).optional(),
	postalCode: r.string().min(1).max(15).register(r.globalRegistry, { description: "The postal code of the address." }).optional(),
	region: r.string().min(1).max(100).register(r.globalRegistry, { description: "The region of the address." }).optional(),
	state: r.string().min(1).max(100).register(r.globalRegistry, { description: "The state of the address." }).optional()
}).register(r.globalRegistry, { description: "A physical address." }), T = r.object({
	height: r.object({
		unit: r.enum([
			"mm",
			"cm",
			"m"
		]).register(r.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: r.int().gte(1).lte(1e6).register(r.globalRegistry, { description: "The dimension value." })
	}).register(r.globalRegistry, { description: "The height." }).optional(),
	length: r.object({
		unit: r.enum([
			"mm",
			"cm",
			"m"
		]).register(r.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: r.int().gte(1).lte(1e6).register(r.globalRegistry, { description: "The dimension value." })
	}).register(r.globalRegistry, { description: "The length." }).optional(),
	weight: r.object({
		unit: r.enum(["g", "kg"]).register(r.globalRegistry, { description: "The unit of weight." }),
		value: r.int().gte(1).lte(999999999)
	}).register(r.globalRegistry, { description: "The weight." }).optional(),
	width: r.object({
		unit: r.enum([
			"mm",
			"cm",
			"m"
		]).register(r.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: r.int().gte(1).lte(1e6).register(r.globalRegistry, { description: "The dimension value." })
	}).register(r.globalRegistry, { description: "The width." }).optional()
}).register(r.globalRegistry, { description: "The physical dimensions." }), E = r.object({
	currency: r.string().length(3).register(r.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
	micros: r.int().gte(0).lte(9007199254740991).register(r.globalRegistry, { description: "The amount of money in integer micros." })
}).register(r.globalRegistry, { description: "A monetary value represented by split integral and fractional parts to avoid floating point errors." }), D = r.object({
	currency: r.string().length(3).register(r.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
	micros: r.int().gte(0).lte(9007199254740991).register(r.globalRegistry, { description: "The amount of money in integer micros." }),
	taxRate: r.int().gte(0).lte(100)
}).register(r.globalRegistry, { description: "A monetary value represented by split integral and fractional parts to avoid floating point errors." }), O = r.object({
	address: w.optional(),
	contact: r.union([r.object({
		emailAddress: r.string().min(1).max(320).register(r.globalRegistry, { description: "An email address." }).optional(),
		locale: r.union([r.string().length(5).register(r.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), r.string().length(2).register(r.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
		phoneNumber: r.string().min(1).max(50).register(r.globalRegistry, { description: "The phone number of the contact." }).optional(),
		type: r.enum(["BUSINESS"]).register(r.globalRegistry, { description: "Discriminator for business contacts." }),
		company: r.string().min(1).max(100).register(r.globalRegistry, { description: "The name of the company." }),
		attention: r.string().min(1).max(100).register(r.globalRegistry, { description: "The name of the contact person." }).optional(),
		vatNumbersByCountry: r.record(r.string(), r.string().min(1).max(20).register(r.globalRegistry, { description: "The VAT registration number for the given country." })).register(r.globalRegistry, { description: "A collection of VAT registration numbers of the company, indexed by ISO country code." }).optional(),
		voecNumber: r.string().min(1).max(20).register(r.globalRegistry, { description: "The VOEC number of the company." }).optional(),
		eoriNumber: r.string().min(1).max(20).register(r.globalRegistry, { description: "The EORI number of the company." }).optional()
	}), r.object({
		emailAddress: r.string().min(1).max(320).register(r.globalRegistry, { description: "An email address." }).optional(),
		locale: r.union([r.string().length(5).register(r.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), r.string().length(2).register(r.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
		phoneNumber: r.string().min(1).max(50).register(r.globalRegistry, { description: "The phone number of the contact." }).optional(),
		type: r.enum(["PRIVATE"]).register(r.globalRegistry, { description: "Discriminator for private contacts." }),
		name: r.string().min(1).max(200).register(r.globalRegistry, { description: "The name of the contact person." })
	})]).optional()
}), k = r.object({
	carrier: r.enum([
		"BPOST",
		"BRT",
		"CHEAP_CARGO",
		"DHL_EUROPLUS",
		"DHL_FOR_YOU",
		"DHL_FREIGHT",
		"DHL_PARCEL_CONNECT",
		"DPD",
		"GLS",
		"INPOST",
		"POSTNL",
		"POSTE_ITALIANE",
		"SPRING",
		"TRUNKRS",
		"UPS_EXPRESS_SAVER",
		"UPS_STANDARD",
		"VIA_TIM"
	]).register(r.globalRegistry, { description: "The carrier to select to ship a package with." }).optional(),
	customContractId: r.string().min(1).max(50).register(r.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	customsDeclaration: r.object({
		groups: r.array(r.object({
			description: r.string().min(1).max(50).register(r.globalRegistry, { description: "A clear and detailed description of the goods within this group." }),
			hsCode: r.string().min(6).max(12).register(r.globalRegistry, { description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products." }),
			numberOfItems: r.int().gte(1).lte(99999).register(r.globalRegistry, { description: "The total quantity of individual items within this specific group." }),
			totalValue: r.object({
				currency: r.string().length(3).register(r.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
				micros: r.int().gte(0).lte(9007199254740991).register(r.globalRegistry, { description: "The amount of money in integer micros." })
			}).register(r.globalRegistry, { description: "The total declared value of all items within this group." }),
			totalWeight: r.object({
				unit: r.enum(["g", "kg"]).register(r.globalRegistry, { description: "The unit of weight." }),
				value: r.int().gte(1).lte(999999999)
			}).register(r.globalRegistry, { description: "The total weight of all items within this specific group." }),
			countryCodeOfOrigin: r.string().length(2).regex(/[A-Z]{2}/).register(r.globalRegistry, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." }).optional()
		}).register(r.globalRegistry, { description: "A consolidated group of items within a customs declaration that share common customs attributes." })).min(1).max(100).register(r.globalRegistry, { description: "The list of item groups." }),
		purpose: r.enum([
			"COMMERCIAL_GOODS",
			"COMMERCIAL_SAMPLE",
			"DOCUMENTS",
			"GIFT",
			"RETURNED_GOODS"
		]).register(r.globalRegistry, { description: "The primary reason or purpose for the international shipment." }),
		totalWeight: r.object({
			unit: r.enum(["g", "kg"]).register(r.globalRegistry, { description: "The unit of weight." }),
			value: r.int().gte(1).lte(999999999)
		}).register(r.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
		invoiceNumber: r.string().min(1).max(150).register(r.globalRegistry, { description: "The identifying number of the commercial invoice associated with this shipment." }).optional()
	}).register(r.globalRegistry, { description: "The official declaration of goods for customs clearance purposes during international shipment." }).optional(),
	delivery: r.object({
		options: r.object({
			notifyOnDelivery: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Notify sender upon package delivery." }).optional(),
			preferredDate: r.object({ date: r.iso.date().register(r.globalRegistry, { description: "Recipient specified preferred delivery date." }) }).register(r.globalRegistry, { description: "This option allows you to set a preferred date for delivery, so a drop off date can be calculated." }).optional()
		}).register(r.globalRegistry, { description: "Options regarding delivery timing and notifications." }).optional(),
		type: r.enum([
			"EARLY_MORNING_DELIVERY",
			"EVENING_DELIVERY",
			"EXPRESS_DELIVERY",
			"MORNING_DELIVERY",
			"PICKUP_EXPRESS_DELIVERY",
			"PICKUP_DELIVERY",
			"SAME_DAY_DELIVERY",
			"STANDARD_DELIVERY"
		]).register(r.globalRegistry, { description: "The delivery type of the shipment." }).optional()
	}).register(r.globalRegistry, { description: "The delivery details of the shipment." }).optional(),
	direction: r.enum(["OUTBOUND", "INBOUND"]).register(r.globalRegistry, { description: "The direction of the shipment. OUTBOUND is from sender to recipient, INBOUND is from recipient to sender." }).optional(),
	disableAutoDetectPickup: r.boolean().register(r.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }).optional(),
	numberOfLabels: r.int().gte(1).lte(20).optional(),
	options: r.object({
		additionalInsurance: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Provides enhanced insurance coverage beyond the standard amount." }).optional(),
		deliverAtPostalPoint: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Indicates that the parcel will be delivered to a designated postal service point rather than the recipient's address, requiring the recipient to collect it from that location." }).optional(),
		freshFood: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Designates the shipment as containing perishable, non-frozen food items, ensuring appropriate handling procedures are applied to maintain freshness and prevent spoilage during transit." }).optional(),
		frozen: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Specifies that the shipment contains items that must remain frozen, necessitating strict, continuous temperature-controlled environments throughout the transit process to prevent thawing." }).optional(),
		hideSender: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Omits the sender's information from the shipping label, maintaining sender anonymity in the delivery process." }).optional(),
		insurance: r.object({ amount: r.object({
			currency: r.string().length(3).register(r.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
			micros: r.int().gte(0).lte(9007199254740991).register(r.globalRegistry, { description: "The amount of money in integer micros." })
		}).register(r.globalRegistry, { description: "The amount to insure." }) }).register(r.globalRegistry, { description: "Provides standard insurance coverage up to the specified monetary amount." }).optional(),
		noTracking: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Disables all tracking and tracing capabilities for the shipment." }).optional(),
		oversizedPackage: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Designates the shipment as exceeding standard size limitations, requiring special handling procedures and potentially incurring additional fees." }).optional(),
		printReturnLabelAtDropOff: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Provides the recipient with a digital identifier that can be presented at a drop-off location to print the return label on-site. This option is only applicable for inbound shipments." }).optional(),
		priorityDelivery: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Designates the shipment for expedited processing and transport through the delivery network, often resulting in a faster transit time compared to standard services." }).optional(),
		recipientOnlyDelivery: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Restricts delivery exclusively to the named recipient, requiring verification of recipient identity and prohibiting delivery to anyone else at the same address." }).optional(),
		requiresAgeVerification: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Requires the recipient to provide valid identification to verify they meet the minimum age requirement before the package can be released, typically used for age-restricted items." }).optional(),
		requiresCashOnDelivery: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Mandates that the carrier collect the full order amount in cash from the recipient upon delivery, ensuring payment is secured before the goods are handed over." }).optional(),
		requiresReceiptCode: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Requires the recipient to provide a specific verification code at the time of delivery, adding an extra layer of security and confirmation for sensitive shipments." }).optional(),
		requiresSignature: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Mandates that the recipient or authorized representative must provide a signature upon delivery, creating proof of receipt and transfer of responsibility." }).optional(),
		returnContributionFee: r.object({ amount: r.object({
			currency: r.string().length(3).register(r.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
			micros: r.int().gte(0).lte(9007199254740991).register(r.globalRegistry, { description: "The amount of money in integer micros." })
		}).register(r.globalRegistry, { description: "The amount of the contribution." }) }).register(r.globalRegistry, { description: "Specifies that the recipient must pay the designated contribution amount toward the cost of returning the item. This option is only applicable for inbound shipments." }).optional(),
		returnOnFirstFailedDelivery: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Instructs the carrier to return the package to the sender immediately after the first unsuccessful delivery attempt, bypassing the standard redelivery procedures or holding period." }).optional(),
		sameDayDelivery: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Expedited delivery within the same calendar day that the shipping label is created." }).optional(),
		saturdayDelivery: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Enables delivery on Saturday, which is typically outside standard delivery days, ensuring the package arrives before the start of the following work week." }).optional(),
		scheduledCollection: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Arranges for the carrier to pick up the package from the sender's location, eliminating the need for the sender to drop off the package." }).optional(),
		customLabelText: r.object({ text: r.string().min(1).max(45).register(r.globalRegistry, { description: "Allows adding personalized text to be printed on the shipping label, which can include special handling instructions or reference information." }) }).register(r.globalRegistry, { description: "Defines a custom text to be printed on the shipping label." }).optional()
	}).register(r.globalRegistry, { description: "The complete set of shipment options." }).optional(),
	packageType: r.enum([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE",
		"UNFRANKED"
	]).register(r.globalRegistry, { description: "The type of the package." }).optional(),
	pickup: r.union([
		r.object({
			address: r.object({
				city: r.string().min(1).max(100).register(r.globalRegistry, { description: "The city of the address." }),
				countryCode: r.string().length(2).regex(/[A-Z]{2}/).register(r.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }),
				street: r.string().min(1).max(100).register(r.globalRegistry, { description: "The street of the address." }),
				additionalInformation: r.string().min(1).max(100).register(r.globalRegistry, { description: "Additional information about the address." }).optional(),
				boxNumber: r.string().min(1).max(20).register(r.globalRegistry, { description: "The box number of the address, only applicable for specific country codes." }).optional(),
				houseNumber: r.string().min(1).max(25).register(r.globalRegistry, { description: "The house number of the address." }).optional(),
				houseNumberSuffix: r.string().min(1).max(25).register(r.globalRegistry, { description: "The house number suffix of the address." }).optional(),
				postalCode: r.string().min(1).max(15).register(r.globalRegistry, { description: "The postal code of the address." }).optional(),
				region: r.string().min(1).max(100).register(r.globalRegistry, { description: "The region of the address." }).optional(),
				state: r.string().min(1).max(100).register(r.globalRegistry, { description: "The state of the address." }).optional()
			}).register(r.globalRegistry, { description: "The address of the pickup location." }),
			location: r.object({
				name: r.string().min(1).max(200).register(r.globalRegistry, { description: "The name of the pickup location." }),
				code: r.string().min(1).max(64).register(r.globalRegistry, { description: "The location code of the pickup location." }).optional(),
				type: r.enum([
					"CLICK_COLLECT",
					"PARCEL_LOCKER",
					"PARCEL_POINT",
					"POST_OFFICE",
					"POST_POINT"
				]).register(r.globalRegistry, { description: "The bpost pickup location type." })
			}).register(r.globalRegistry, { description: "The pickup location details." })
		}).register(r.globalRegistry, { description: "The bpost pickup details." }),
		r.object({
			address: r.object({
				city: r.string().min(1).max(100).register(r.globalRegistry, { description: "The city of the address." }),
				countryCode: r.string().length(2).regex(/[A-Z]{2}/).register(r.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }),
				street: r.string().min(1).max(100).register(r.globalRegistry, { description: "The street of the address." }),
				additionalInformation: r.string().min(1).max(100).register(r.globalRegistry, { description: "Additional information about the address." }).optional(),
				boxNumber: r.string().min(1).max(20).register(r.globalRegistry, { description: "The box number of the address, only applicable for specific country codes." }).optional(),
				houseNumber: r.string().min(1).max(25).register(r.globalRegistry, { description: "The house number of the address." }).optional(),
				houseNumberSuffix: r.string().min(1).max(25).register(r.globalRegistry, { description: "The house number suffix of the address." }).optional(),
				postalCode: r.string().min(1).max(15).register(r.globalRegistry, { description: "The postal code of the address." }).optional(),
				region: r.string().min(1).max(100).register(r.globalRegistry, { description: "The region of the address." }).optional(),
				state: r.string().min(1).max(100).register(r.globalRegistry, { description: "The state of the address." }).optional()
			}).register(r.globalRegistry, { description: "The address of the pickup location." }),
			location: r.object({
				name: r.string().min(1).max(200).register(r.globalRegistry, { description: "The name of the pickup location." }),
				code: r.string().min(1).max(64).register(r.globalRegistry, { description: "The location code of the pickup location." }).optional()
			}).register(r.globalRegistry, { description: "The pickup location details." }),
			retailNetworkId: r.enum(["PNPNL-01", "PNPBE-01"]).register(r.globalRegistry, { description: "PostNL Retail network ID." })
		}).register(r.globalRegistry, { description: "The PostNL pickup details." }),
		r.object({
			address: r.object({
				city: r.string().min(1).max(100).register(r.globalRegistry, { description: "The city of the address." }),
				countryCode: r.string().length(2).regex(/[A-Z]{2}/).register(r.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }),
				street: r.string().min(1).max(100).register(r.globalRegistry, { description: "The street of the address." }),
				additionalInformation: r.string().min(1).max(100).register(r.globalRegistry, { description: "Additional information about the address." }).optional(),
				boxNumber: r.string().min(1).max(20).register(r.globalRegistry, { description: "The box number of the address, only applicable for specific country codes." }).optional(),
				houseNumber: r.string().min(1).max(25).register(r.globalRegistry, { description: "The house number of the address." }).optional(),
				houseNumberSuffix: r.string().min(1).max(25).register(r.globalRegistry, { description: "The house number suffix of the address." }).optional(),
				postalCode: r.string().min(1).max(15).register(r.globalRegistry, { description: "The postal code of the address." }).optional(),
				region: r.string().min(1).max(100).register(r.globalRegistry, { description: "The region of the address." }).optional(),
				state: r.string().min(1).max(100).register(r.globalRegistry, { description: "The state of the address." }).optional()
			}).register(r.globalRegistry, { description: "The address of the pickup location." }),
			location: r.object({
				name: r.string().min(1).max(200).register(r.globalRegistry, { description: "The name of the pickup location." }),
				code: r.string().min(1).max(64).register(r.globalRegistry, { description: "The location code of the pickup location." }).optional()
			}).register(r.globalRegistry, { description: "The pickup location details." })
		}).register(r.globalRegistry, { description: "The general pickup details." })
	]).optional(),
	recipient: r.object({
		address: r.object({
			city: r.string().min(1).max(100).register(r.globalRegistry, { description: "The city of the address." }),
			countryCode: r.string().length(2).regex(/[A-Z]{2}/).register(r.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }),
			street: r.string().min(1).max(100).register(r.globalRegistry, { description: "The street of the address." }),
			additionalInformation: r.string().min(1).max(100).register(r.globalRegistry, { description: "Additional information about the address." }).optional(),
			boxNumber: r.string().min(1).max(20).register(r.globalRegistry, { description: "The box number of the address, only applicable for specific country codes." }).optional(),
			houseNumber: r.string().min(1).max(25).register(r.globalRegistry, { description: "The house number of the address." }).optional(),
			houseNumberSuffix: r.string().min(1).max(25).register(r.globalRegistry, { description: "The house number suffix of the address." }).optional(),
			postalCode: r.string().min(1).max(15).register(r.globalRegistry, { description: "The postal code of the address." }).optional(),
			region: r.string().min(1).max(100).register(r.globalRegistry, { description: "The region of the address." }).optional(),
			state: r.string().min(1).max(100).register(r.globalRegistry, { description: "The state of the address." }).optional()
		}).register(r.globalRegistry, { description: "The address of the recipient." }).optional(),
		contact: r.union([r.object({
			locale: r.union([r.string().length(5).register(r.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), r.string().length(2).register(r.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
			phoneNumber: r.string().min(1).max(50).register(r.globalRegistry, { description: "The phone number of the contact." }).optional(),
			type: r.enum(["BUSINESS"]).register(r.globalRegistry, { description: "Discriminator for business contacts." }),
			company: r.string().min(1).max(100).register(r.globalRegistry, { description: "The name of the company." }),
			attention: r.string().min(1).max(100).register(r.globalRegistry, { description: "The name of the contact person." }).optional(),
			vatNumbersByCountry: r.record(r.string(), r.string().min(1).max(20).register(r.globalRegistry, { description: "The VAT registration number for the given country." })).register(r.globalRegistry, { description: "A collection of VAT registration numbers of the company, indexed by ISO country code." }).optional(),
			voecNumber: r.string().min(1).max(20).register(r.globalRegistry, { description: "The VOEC number of the company." }).optional(),
			eoriNumber: r.string().min(1).max(20).register(r.globalRegistry, { description: "The EORI number of the company." }).optional(),
			emailAddresses: r.array(r.string().min(1).max(320).register(r.globalRegistry, { description: "An email address." })).min(1).max(5).register(r.globalRegistry, { description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present." }).optional()
		}).register(r.globalRegistry, { description: "A business contact that supports multiple email addresses." }), r.object({
			locale: r.union([r.string().length(5).register(r.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), r.string().length(2).register(r.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
			phoneNumber: r.string().min(1).max(50).register(r.globalRegistry, { description: "The phone number of the contact." }).optional(),
			type: r.enum(["PRIVATE"]).register(r.globalRegistry, { description: "Discriminator for private contacts." }),
			name: r.string().min(1).max(200).register(r.globalRegistry, { description: "The name of the contact person." }),
			emailAddresses: r.array(r.string().min(1).max(320).register(r.globalRegistry, { description: "An email address." })).min(1).max(5).register(r.globalRegistry, { description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present." }).optional()
		}).register(r.globalRegistry, { description: "A private contact that supports multiple email addresses." })]).optional()
	}).register(r.globalRegistry, { description: "The recipient of the shipment." }).optional()
}).register(r.globalRegistry, { description: "The shipping preferences of the order. This should be used as default information when preparing packages for shipment." }), A = r.object({
	barcode: r.string().min(6).max(24).optional(),
	containsDangerousSubstances: r.boolean().optional(),
	countryCodeOfOrigin: r.string().length(2).regex(/[A-Z]{2}/).register(r.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }).optional(),
	descriptions: r.array(r.object({
		text: r.string().min(1).max(2500).register(r.globalRegistry, { description: "The text of one of the product descriptions." }),
		languageCode: r.string().length(2).register(r.globalRegistry, { description: "The language code (ISO 639-1) of one of the product descriptions." })
	})).min(1).max(200).register(r.globalRegistry, { description: "The descriptions of the product." }).optional(),
	ean: r.string().min(1).max(13).optional(),
	fulfilment: r.object({
		platforms: r.array(r.enum(["VASCO"]).register(r.globalRegistry, { description: "The fulfilment platform." })).min(1),
		trackInventory: r.boolean().optional()
	}).optional(),
	hasUnlimitedShelfLife: r.boolean().optional(),
	hsCode: r.string().min(6).max(10).register(r.globalRegistry, { description: "The HS code of the product." }).optional(),
	name: r.string(),
	physicalProperties: T.optional(),
	purchasePrice: E.optional(),
	salesPrice: D.optional(),
	sku: r.string().optional()
}), j = A.and(r.object({ sourceId: r.string().min(1).max(50).register(r.globalRegistry, { description: "The product ID as defined in the source system." }) })), M = r.object({
	billingDetails: O.and(r.unknown().register(r.globalRegistry, { description: "Billing details of the order." })).optional(),
	customerReference: r.string().min(1).max(100).register(r.globalRegistry, { description: "The customer reference of the order." }).optional(),
	orderedAt: r.iso.datetime().register(r.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." }),
	shipping: k.optional(),
	sourceId: r.string().min(1).max(50).register(r.globalRegistry, { description: "The order ID as defined in the source system." })
}), N = r.object({
	billingDetails: O.and(r.unknown().register(r.globalRegistry, { description: "Billing details of the order." })).optional(),
	customerReference: r.string().min(1).max(100).register(r.globalRegistry, { description: "The customer reference of the order." }).optional(),
	orderedAt: r.iso.datetime().register(r.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." }),
	shipping: k.optional(),
	sourceId: r.string().min(1).max(50).register(r.globalRegistry, { description: "The order ID as defined in the source system." }),
	lines: r.array(r.object({
		price: E.optional(),
		product: j,
		quantity: r.int().gt(0),
		sourceId: r.string().min(1).max(50).register(r.globalRegistry, { description: "The line ID as defined in the source system." })
	})).min(1).optional(),
	salesChannelId: r.uuid()
}), P = r.object({
	billingDetails: O.and(r.unknown().register(r.globalRegistry, { description: "Billing details of the order." })).optional(),
	customerReference: r.string().min(1).max(100).register(r.globalRegistry, { description: "The customer reference of the order." }).optional(),
	orderedAt: r.iso.datetime().register(r.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." }),
	shipping: k.optional(),
	sourceId: r.string().min(1).max(50).register(r.globalRegistry, { description: "The order ID as defined in the source system." }),
	lines: r.array(r.object({
		price: E.optional(),
		product: A,
		quantity: r.int().gt(0)
	})).min(1).optional(),
	shopId: r.string().min(1).max(50).register(r.globalRegistry, { description: "The unique identifier of the shop." })
}), F = r.object({
	createdAt: r.union([r.string(), r.iso.datetime().register(r.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	id: r.string().min(1).max(50).register(r.globalRegistry, { description: "The sales channel ID." }),
	name: r.string().min(3).max(50).register(r.globalRegistry, { description: "Custom sales channel name." }),
	shopId: r.string().min(1).max(50).register(r.globalRegistry, { description: "Owning shop ID for the sales channel." }),
	url: r.url().max(250).register(r.globalRegistry, { description: "The URL of the sales channel." })
}), I = r.object({
	type: r.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]).register(r.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: r.union([
		r.literal(400),
		r.literal(401),
		r.literal(404),
		r.literal(415),
		r.literal(500)
	]).register(r.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: r.string().min(1).max(100).register(r.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: r.string().min(1).max(5e3).register(r.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: r.url().register(r.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: r.unknown().register(r.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}), L = I.and(r.object({
	type: r.enum(["urn:problem:client"]).register(r.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: r.literal(400).register(r.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: r.array(r.object({
		detail: r.string().min(1).max(5e3),
		pointer: r.string().min(1).max(200).register(r.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).min(1).register(r.globalRegistry, { description: "Detailed information regarding the violations." })
})), R = I.and(r.object({
	type: r.enum(["urn:problem:server"]).register(r.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: r.literal(500).register(r.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional()
})), ce = I.and(r.object({
	type: r.enum(["urn:problem:invalid-request-syntax"]).register(r.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: r.literal(400).register(r.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: r.array(r.object({
		detail: r.string().min(1).max(5e3),
		pointer: r.string().min(1).max(200).register(r.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).min(1).register(r.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), le = I.and(r.object({
	type: r.enum(["urn:problem:not-found"]).register(r.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: r.literal(404).register(r.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional()
})), z = r.object({
	body: r.array(r.union([N, P])).min(1).max(50).register(r.globalRegistry, { description: "Body for ingesting orders." }),
	path: r.never().optional(),
	query: r.never().optional()
}), ue = r.array(r.union([
	r.object({ status: r.literal(202) }),
	L,
	R
])).max(50).register(r.globalRegistry, { description: "The result per item." }), B = r.object({
	body: r.never().optional(),
	path: r.never().optional(),
	query: r.object({ filter: r.object({ shopId: r.array(r.string().min(1).max(50).register(r.globalRegistry, { description: "The unique identifier of the shop." })).min(1).max(100).optional() }).optional() }).optional()
}), de = r.object({ results: r.array(F) }).register(r.globalRegistry, { description: "Found sales channels." }), V = r.object({
	body: r.object({
		name: r.string().min(3).max(50).register(r.globalRegistry, { description: "The name of the sales channel." }),
		shopId: r.string().min(1).max(50).register(r.globalRegistry, { description: "The shop ID of the sales channel." }),
		url: r.url().max(250).register(r.globalRegistry, { description: "The URL of the sales channel." })
	}).register(r.globalRegistry, { description: "Body for creating a sales channel." }),
	path: r.never().optional(),
	query: r.never().optional()
}), H = F, U = r.object({
	body: r.never().optional(),
	path: r.object({ salesChannelId: r.string().min(1).max(50).register(r.globalRegistry, { description: "The ID of the sales channel." }) }),
	query: r.never().optional()
}), fe = F, W = r.object({
	body: r.object({ salesChannelId: r.string().min(1).max(50).register(r.globalRegistry, { description: "The ID of the sales channel." }) }).register(r.globalRegistry, { description: "Body for removing a sales channel." }),
	path: r.never().optional(),
	query: r.never().optional()
}), pe = r.void().register(r.globalRegistry, { description: "The sales channel has been removed." }), G = r.object({
	body: r.object({
		name: r.string().min(3).max(50).register(r.globalRegistry, { description: "The name of the sales channel." }),
		salesChannelId: r.string().min(1).max(50).register(r.globalRegistry, { description: "The ID of the sales channel." })
	}).register(r.globalRegistry, { description: "Body for renaming a sales channel." }),
	path: r.never().optional(),
	query: r.never().optional()
}), me = F, he = r.object({
	city: r.string().register(r.globalRegistry, { description: "The city of the address." }),
	countryCode: r.string().register(r.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }),
	street: r.string().register(r.globalRegistry, { description: "The street of the address." }),
	additionalInformation: r.string().register(r.globalRegistry, { description: "Additional information about the address." }).optional(),
	boxNumber: r.string().register(r.globalRegistry, { description: "The box number of the address, only applicable for specific country codes." }).optional(),
	houseNumber: r.string().register(r.globalRegistry, { description: "The house number of the address." }).optional(),
	houseNumberSuffix: r.string().register(r.globalRegistry, { description: "The house number suffix of the address." }).optional(),
	postalCode: r.string().register(r.globalRegistry, { description: "The postal code of the address." }).optional(),
	region: r.string().register(r.globalRegistry, { description: "The region of the address." }).optional(),
	state: r.string().register(r.globalRegistry, { description: "The state of the address." }).optional()
}).register(r.globalRegistry, { description: "A physical address." }), ge = r.object({
	height: r.object({
		unit: r.union([r.enum([
			"mm",
			"cm",
			"m"
		]), r.string()]).register(r.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: r.int().gte(1).lte(1e6).register(r.globalRegistry, { description: "The dimension value." })
	}).register(r.globalRegistry, { description: "The height." }).optional(),
	length: r.object({
		unit: r.union([r.enum([
			"mm",
			"cm",
			"m"
		]), r.string()]).register(r.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: r.int().gte(1).lte(1e6).register(r.globalRegistry, { description: "The dimension value." })
	}).register(r.globalRegistry, { description: "The length." }).optional(),
	weight: r.object({
		unit: r.union([r.enum(["g", "kg"]), r.string()]).register(r.globalRegistry, { description: "The unit of weight." }),
		value: r.int().gte(1).lte(999999999)
	}).register(r.globalRegistry, { description: "The weight." }).optional(),
	width: r.object({
		unit: r.union([r.enum([
			"mm",
			"cm",
			"m"
		]), r.string()]).register(r.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: r.int().gte(1).lte(1e6).register(r.globalRegistry, { description: "The dimension value." })
	}).register(r.globalRegistry, { description: "The width." }).optional()
}).register(r.globalRegistry, { description: "The physical dimensions." }), K = r.object({
	currency: r.string().register(r.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
	micros: r.int().gte(0).lte(9007199254740991).register(r.globalRegistry, { description: "The amount of money in integer micros." })
}).register(r.globalRegistry, { description: "A monetary value represented by split integral and fractional parts to avoid floating point errors." }), _e = r.object({
	currency: r.string().register(r.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
	micros: r.int().gte(0).lte(9007199254740991).register(r.globalRegistry, { description: "The amount of money in integer micros." }),
	taxRate: r.int().gte(0).lte(100)
}).register(r.globalRegistry, { description: "A monetary value represented by split integral and fractional parts to avoid floating point errors." }), q = r.object({
	address: he.optional(),
	contact: r.union([r.object({
		emailAddress: r.string().register(r.globalRegistry, { description: "An email address." }).optional(),
		locale: r.union([r.string().register(r.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), r.string().register(r.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
		phoneNumber: r.string().register(r.globalRegistry, { description: "The phone number of the contact." }).optional(),
		type: r.union([r.enum(["BUSINESS"]), r.string()]).register(r.globalRegistry, { description: "Discriminator for business contacts." }),
		company: r.string().register(r.globalRegistry, { description: "The name of the company." }),
		attention: r.string().register(r.globalRegistry, { description: "The name of the contact person." }).optional(),
		vatNumbersByCountry: r.record(r.string(), r.string().register(r.globalRegistry, { description: "The VAT registration number for the given country." })).register(r.globalRegistry, { description: "A collection of VAT registration numbers of the company, indexed by ISO country code." }).optional(),
		voecNumber: r.string().register(r.globalRegistry, { description: "The VOEC number of the company." }).optional(),
		eoriNumber: r.string().register(r.globalRegistry, { description: "The EORI number of the company." }).optional()
	}), r.object({
		emailAddress: r.string().register(r.globalRegistry, { description: "An email address." }).optional(),
		locale: r.union([r.string().register(r.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), r.string().register(r.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
		phoneNumber: r.string().register(r.globalRegistry, { description: "The phone number of the contact." }).optional(),
		type: r.union([r.enum(["PRIVATE"]), r.string()]).register(r.globalRegistry, { description: "Discriminator for private contacts." }),
		name: r.string().register(r.globalRegistry, { description: "The name of the contact person." })
	})]).optional()
}), J = r.object({
	carrier: r.union([r.enum([
		"BPOST",
		"BRT",
		"CHEAP_CARGO",
		"DHL_EUROPLUS",
		"DHL_FOR_YOU",
		"DHL_FREIGHT",
		"DHL_PARCEL_CONNECT",
		"DPD",
		"GLS",
		"INPOST",
		"POSTNL",
		"POSTE_ITALIANE",
		"SPRING",
		"TRUNKRS",
		"UPS_EXPRESS_SAVER",
		"UPS_STANDARD",
		"VIA_TIM"
	]), r.string()]).register(r.globalRegistry, { description: "The carrier to select to ship a package with." }).optional(),
	customContractId: r.string().register(r.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	customsDeclaration: r.object({
		groups: r.array(r.object({
			description: r.string().register(r.globalRegistry, { description: "A clear and detailed description of the goods within this group." }),
			hsCode: r.string().register(r.globalRegistry, { description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products." }),
			numberOfItems: r.int().gte(1).lte(99999).register(r.globalRegistry, { description: "The total quantity of individual items within this specific group." }),
			totalValue: r.object({
				currency: r.string().register(r.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
				micros: r.int().gte(0).lte(9007199254740991).register(r.globalRegistry, { description: "The amount of money in integer micros." })
			}).register(r.globalRegistry, { description: "The total declared value of all items within this group." }),
			totalWeight: r.object({
				unit: r.union([r.enum(["g", "kg"]), r.string()]).register(r.globalRegistry, { description: "The unit of weight." }),
				value: r.int().gte(1).lte(999999999)
			}).register(r.globalRegistry, { description: "The total weight of all items within this specific group." }),
			countryCodeOfOrigin: r.string().register(r.globalRegistry, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." }).optional()
		}).register(r.globalRegistry, { description: "A consolidated group of items within a customs declaration that share common customs attributes." })).register(r.globalRegistry, { description: "The list of item groups." }),
		purpose: r.union([r.enum([
			"COMMERCIAL_GOODS",
			"COMMERCIAL_SAMPLE",
			"DOCUMENTS",
			"GIFT",
			"RETURNED_GOODS"
		]), r.string()]).register(r.globalRegistry, { description: "The primary reason or purpose for the international shipment." }),
		totalWeight: r.object({
			unit: r.union([r.enum(["g", "kg"]), r.string()]).register(r.globalRegistry, { description: "The unit of weight." }),
			value: r.int().gte(1).lte(999999999)
		}).register(r.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
		invoiceNumber: r.string().register(r.globalRegistry, { description: "The identifying number of the commercial invoice associated with this shipment." }).optional()
	}).register(r.globalRegistry, { description: "The official declaration of goods for customs clearance purposes during international shipment." }).optional(),
	delivery: r.object({
		options: r.object({
			notifyOnDelivery: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Notify sender upon package delivery." }).optional(),
			preferredDate: r.object({ date: r.iso.date().register(r.globalRegistry, { description: "Recipient specified preferred delivery date." }) }).register(r.globalRegistry, { description: "This option allows you to set a preferred date for delivery, so a drop off date can be calculated." }).optional()
		}).register(r.globalRegistry, { description: "Options regarding delivery timing and notifications." }).optional(),
		type: r.union([r.enum([
			"EARLY_MORNING_DELIVERY",
			"EVENING_DELIVERY",
			"EXPRESS_DELIVERY",
			"MORNING_DELIVERY",
			"PICKUP_EXPRESS_DELIVERY",
			"PICKUP_DELIVERY",
			"SAME_DAY_DELIVERY",
			"STANDARD_DELIVERY"
		]), r.string()]).register(r.globalRegistry, { description: "The delivery type of the shipment." }).optional()
	}).register(r.globalRegistry, { description: "The delivery details of the shipment." }).optional(),
	direction: r.union([r.enum(["OUTBOUND", "INBOUND"]), r.string()]).register(r.globalRegistry, { description: "The direction of the shipment. OUTBOUND is from sender to recipient, INBOUND is from recipient to sender." }).optional(),
	disableAutoDetectPickup: r.boolean().register(r.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }).optional(),
	numberOfLabels: r.int().gte(1).lte(20).optional(),
	options: r.object({
		additionalInsurance: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Provides enhanced insurance coverage beyond the standard amount." }).optional(),
		deliverAtPostalPoint: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Indicates that the parcel will be delivered to a designated postal service point rather than the recipient's address, requiring the recipient to collect it from that location." }).optional(),
		freshFood: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Designates the shipment as containing perishable, non-frozen food items, ensuring appropriate handling procedures are applied to maintain freshness and prevent spoilage during transit." }).optional(),
		frozen: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Specifies that the shipment contains items that must remain frozen, necessitating strict, continuous temperature-controlled environments throughout the transit process to prevent thawing." }).optional(),
		hideSender: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Omits the sender's information from the shipping label, maintaining sender anonymity in the delivery process." }).optional(),
		insurance: r.object({ amount: r.object({
			currency: r.string().register(r.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
			micros: r.int().gte(0).lte(9007199254740991).register(r.globalRegistry, { description: "The amount of money in integer micros." })
		}).register(r.globalRegistry, { description: "The amount to insure." }) }).register(r.globalRegistry, { description: "Provides standard insurance coverage up to the specified monetary amount." }).optional(),
		noTracking: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Disables all tracking and tracing capabilities for the shipment." }).optional(),
		oversizedPackage: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Designates the shipment as exceeding standard size limitations, requiring special handling procedures and potentially incurring additional fees." }).optional(),
		printReturnLabelAtDropOff: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Provides the recipient with a digital identifier that can be presented at a drop-off location to print the return label on-site. This option is only applicable for inbound shipments." }).optional(),
		priorityDelivery: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Designates the shipment for expedited processing and transport through the delivery network, often resulting in a faster transit time compared to standard services." }).optional(),
		recipientOnlyDelivery: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Restricts delivery exclusively to the named recipient, requiring verification of recipient identity and prohibiting delivery to anyone else at the same address." }).optional(),
		requiresAgeVerification: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Requires the recipient to provide valid identification to verify they meet the minimum age requirement before the package can be released, typically used for age-restricted items." }).optional(),
		requiresCashOnDelivery: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Mandates that the carrier collect the full order amount in cash from the recipient upon delivery, ensuring payment is secured before the goods are handed over." }).optional(),
		requiresReceiptCode: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Requires the recipient to provide a specific verification code at the time of delivery, adding an extra layer of security and confirmation for sensitive shipments." }).optional(),
		requiresSignature: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Mandates that the recipient or authorized representative must provide a signature upon delivery, creating proof of receipt and transfer of responsibility." }).optional(),
		returnContributionFee: r.object({ amount: r.object({
			currency: r.string().register(r.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
			micros: r.int().gte(0).lte(9007199254740991).register(r.globalRegistry, { description: "The amount of money in integer micros." })
		}).register(r.globalRegistry, { description: "The amount of the contribution." }) }).register(r.globalRegistry, { description: "Specifies that the recipient must pay the designated contribution amount toward the cost of returning the item. This option is only applicable for inbound shipments." }).optional(),
		returnOnFirstFailedDelivery: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Instructs the carrier to return the package to the sender immediately after the first unsuccessful delivery attempt, bypassing the standard redelivery procedures or holding period." }).optional(),
		sameDayDelivery: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Expedited delivery within the same calendar day that the shipping label is created." }).optional(),
		saturdayDelivery: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Enables delivery on Saturday, which is typically outside standard delivery days, ensuring the package arrives before the start of the following work week." }).optional(),
		scheduledCollection: r.record(r.string(), r.never()).register(r.globalRegistry, { description: "Arranges for the carrier to pick up the package from the sender's location, eliminating the need for the sender to drop off the package." }).optional(),
		customLabelText: r.object({ text: r.string().register(r.globalRegistry, { description: "Allows adding personalized text to be printed on the shipping label, which can include special handling instructions or reference information." }) }).register(r.globalRegistry, { description: "Defines a custom text to be printed on the shipping label." }).optional()
	}).register(r.globalRegistry, { description: "The complete set of shipment options." }).optional(),
	packageType: r.union([r.enum([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE",
		"UNFRANKED"
	]), r.string()]).register(r.globalRegistry, { description: "The type of the package." }).optional(),
	pickup: r.union([
		r.object({
			address: r.object({
				city: r.string().register(r.globalRegistry, { description: "The city of the address." }),
				countryCode: r.string().register(r.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }),
				street: r.string().register(r.globalRegistry, { description: "The street of the address." }),
				additionalInformation: r.string().register(r.globalRegistry, { description: "Additional information about the address." }).optional(),
				boxNumber: r.string().register(r.globalRegistry, { description: "The box number of the address, only applicable for specific country codes." }).optional(),
				houseNumber: r.string().register(r.globalRegistry, { description: "The house number of the address." }).optional(),
				houseNumberSuffix: r.string().register(r.globalRegistry, { description: "The house number suffix of the address." }).optional(),
				postalCode: r.string().register(r.globalRegistry, { description: "The postal code of the address." }).optional(),
				region: r.string().register(r.globalRegistry, { description: "The region of the address." }).optional(),
				state: r.string().register(r.globalRegistry, { description: "The state of the address." }).optional()
			}).register(r.globalRegistry, { description: "The address of the pickup location." }),
			location: r.object({
				name: r.string().register(r.globalRegistry, { description: "The name of the pickup location." }),
				code: r.string().register(r.globalRegistry, { description: "The location code of the pickup location." }).optional(),
				type: r.union([r.enum([
					"CLICK_COLLECT",
					"PARCEL_LOCKER",
					"PARCEL_POINT",
					"POST_OFFICE",
					"POST_POINT"
				]), r.string()]).register(r.globalRegistry, { description: "The bpost pickup location type." })
			}).register(r.globalRegistry, { description: "The pickup location details." })
		}).register(r.globalRegistry, { description: "The bpost pickup details." }),
		r.object({
			address: r.object({
				city: r.string().register(r.globalRegistry, { description: "The city of the address." }),
				countryCode: r.string().register(r.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }),
				street: r.string().register(r.globalRegistry, { description: "The street of the address." }),
				additionalInformation: r.string().register(r.globalRegistry, { description: "Additional information about the address." }).optional(),
				boxNumber: r.string().register(r.globalRegistry, { description: "The box number of the address, only applicable for specific country codes." }).optional(),
				houseNumber: r.string().register(r.globalRegistry, { description: "The house number of the address." }).optional(),
				houseNumberSuffix: r.string().register(r.globalRegistry, { description: "The house number suffix of the address." }).optional(),
				postalCode: r.string().register(r.globalRegistry, { description: "The postal code of the address." }).optional(),
				region: r.string().register(r.globalRegistry, { description: "The region of the address." }).optional(),
				state: r.string().register(r.globalRegistry, { description: "The state of the address." }).optional()
			}).register(r.globalRegistry, { description: "The address of the pickup location." }),
			location: r.object({
				name: r.string().register(r.globalRegistry, { description: "The name of the pickup location." }),
				code: r.string().register(r.globalRegistry, { description: "The location code of the pickup location." }).optional()
			}).register(r.globalRegistry, { description: "The pickup location details." }),
			retailNetworkId: r.union([r.enum(["PNPNL-01", "PNPBE-01"]), r.string()]).register(r.globalRegistry, { description: "PostNL Retail network ID." })
		}).register(r.globalRegistry, { description: "The PostNL pickup details." }),
		r.object({
			address: r.object({
				city: r.string().register(r.globalRegistry, { description: "The city of the address." }),
				countryCode: r.string().register(r.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }),
				street: r.string().register(r.globalRegistry, { description: "The street of the address." }),
				additionalInformation: r.string().register(r.globalRegistry, { description: "Additional information about the address." }).optional(),
				boxNumber: r.string().register(r.globalRegistry, { description: "The box number of the address, only applicable for specific country codes." }).optional(),
				houseNumber: r.string().register(r.globalRegistry, { description: "The house number of the address." }).optional(),
				houseNumberSuffix: r.string().register(r.globalRegistry, { description: "The house number suffix of the address." }).optional(),
				postalCode: r.string().register(r.globalRegistry, { description: "The postal code of the address." }).optional(),
				region: r.string().register(r.globalRegistry, { description: "The region of the address." }).optional(),
				state: r.string().register(r.globalRegistry, { description: "The state of the address." }).optional()
			}).register(r.globalRegistry, { description: "The address of the pickup location." }),
			location: r.object({
				name: r.string().register(r.globalRegistry, { description: "The name of the pickup location." }),
				code: r.string().register(r.globalRegistry, { description: "The location code of the pickup location." }).optional()
			}).register(r.globalRegistry, { description: "The pickup location details." })
		}).register(r.globalRegistry, { description: "The general pickup details." })
	]).optional(),
	recipient: r.object({
		address: r.object({
			city: r.string().register(r.globalRegistry, { description: "The city of the address." }),
			countryCode: r.string().register(r.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }),
			street: r.string().register(r.globalRegistry, { description: "The street of the address." }),
			additionalInformation: r.string().register(r.globalRegistry, { description: "Additional information about the address." }).optional(),
			boxNumber: r.string().register(r.globalRegistry, { description: "The box number of the address, only applicable for specific country codes." }).optional(),
			houseNumber: r.string().register(r.globalRegistry, { description: "The house number of the address." }).optional(),
			houseNumberSuffix: r.string().register(r.globalRegistry, { description: "The house number suffix of the address." }).optional(),
			postalCode: r.string().register(r.globalRegistry, { description: "The postal code of the address." }).optional(),
			region: r.string().register(r.globalRegistry, { description: "The region of the address." }).optional(),
			state: r.string().register(r.globalRegistry, { description: "The state of the address." }).optional()
		}).register(r.globalRegistry, { description: "The address of the recipient." }).optional(),
		contact: r.union([r.object({
			locale: r.union([r.string().register(r.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), r.string().register(r.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
			phoneNumber: r.string().register(r.globalRegistry, { description: "The phone number of the contact." }).optional(),
			type: r.union([r.enum(["BUSINESS"]), r.string()]).register(r.globalRegistry, { description: "Discriminator for business contacts." }),
			company: r.string().register(r.globalRegistry, { description: "The name of the company." }),
			attention: r.string().register(r.globalRegistry, { description: "The name of the contact person." }).optional(),
			vatNumbersByCountry: r.record(r.string(), r.string().register(r.globalRegistry, { description: "The VAT registration number for the given country." })).register(r.globalRegistry, { description: "A collection of VAT registration numbers of the company, indexed by ISO country code." }).optional(),
			voecNumber: r.string().register(r.globalRegistry, { description: "The VOEC number of the company." }).optional(),
			eoriNumber: r.string().register(r.globalRegistry, { description: "The EORI number of the company." }).optional(),
			emailAddresses: r.array(r.string().register(r.globalRegistry, { description: "An email address." })).register(r.globalRegistry, { description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present." }).optional()
		}).register(r.globalRegistry, { description: "A business contact that supports multiple email addresses." }), r.object({
			locale: r.union([r.string().register(r.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), r.string().register(r.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
			phoneNumber: r.string().register(r.globalRegistry, { description: "The phone number of the contact." }).optional(),
			type: r.union([r.enum(["PRIVATE"]), r.string()]).register(r.globalRegistry, { description: "Discriminator for private contacts." }),
			name: r.string().register(r.globalRegistry, { description: "The name of the contact person." }),
			emailAddresses: r.array(r.string().register(r.globalRegistry, { description: "An email address." })).register(r.globalRegistry, { description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present." }).optional()
		}).register(r.globalRegistry, { description: "A private contact that supports multiple email addresses." })]).optional()
	}).register(r.globalRegistry, { description: "The recipient of the shipment." }).optional()
}).register(r.globalRegistry, { description: "The shipping preferences of the order. This should be used as default information when preparing packages for shipment." }), Y = r.object({
	barcode: r.string().optional(),
	containsDangerousSubstances: r.boolean().optional(),
	countryCodeOfOrigin: r.string().register(r.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }).optional(),
	descriptions: r.array(r.object({
		text: r.string().register(r.globalRegistry, { description: "The text of one of the product descriptions." }),
		languageCode: r.string().register(r.globalRegistry, { description: "The language code (ISO 639-1) of one of the product descriptions." })
	})).register(r.globalRegistry, { description: "The descriptions of the product." }).optional(),
	ean: r.string().optional(),
	fulfilment: r.object({
		platforms: r.array(r.union([r.enum(["VASCO"]), r.string()]).register(r.globalRegistry, { description: "The fulfilment platform." })),
		trackInventory: r.boolean().optional()
	}).optional(),
	hasUnlimitedShelfLife: r.boolean().optional(),
	hsCode: r.string().register(r.globalRegistry, { description: "The HS code of the product." }).optional(),
	name: r.string(),
	physicalProperties: ge.optional(),
	purchasePrice: K.optional(),
	salesPrice: _e.optional(),
	sku: r.string().optional()
}), ve = Y.and(r.object({ sourceId: r.string().register(r.globalRegistry, { description: "The product ID as defined in the source system." }) }));
r.object({
	billingDetails: q.and(r.unknown().register(r.globalRegistry, { description: "Billing details of the order." })).optional(),
	customerReference: r.string().register(r.globalRegistry, { description: "The customer reference of the order." }).optional(),
	orderedAt: r.iso.datetime().register(r.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." }),
	shipping: J.optional(),
	sourceId: r.string().register(r.globalRegistry, { description: "The order ID as defined in the source system." })
});
var ye = r.object({
	billingDetails: q.and(r.unknown().register(r.globalRegistry, { description: "Billing details of the order." })).optional(),
	customerReference: r.string().register(r.globalRegistry, { description: "The customer reference of the order." }).optional(),
	orderedAt: r.iso.datetime().register(r.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." }),
	shipping: J.optional(),
	sourceId: r.string().register(r.globalRegistry, { description: "The order ID as defined in the source system." }),
	lines: r.array(r.object({
		price: K.optional(),
		product: ve,
		quantity: r.int().gt(0),
		sourceId: r.string().register(r.globalRegistry, { description: "The line ID as defined in the source system." })
	})).optional(),
	salesChannelId: r.uuid()
}), be = r.object({
	billingDetails: q.and(r.unknown().register(r.globalRegistry, { description: "Billing details of the order." })).optional(),
	customerReference: r.string().register(r.globalRegistry, { description: "The customer reference of the order." }).optional(),
	orderedAt: r.iso.datetime().register(r.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." }),
	shipping: J.optional(),
	sourceId: r.string().register(r.globalRegistry, { description: "The order ID as defined in the source system." }),
	lines: r.array(r.object({
		price: K.optional(),
		product: Y,
		quantity: r.int().gt(0)
	})).optional(),
	shopId: r.string().register(r.globalRegistry, { description: "The unique identifier of the shop." })
}), X = r.object({
	createdAt: r.union([r.string(), r.iso.datetime().register(r.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	id: r.string().register(r.globalRegistry, { description: "The sales channel ID." }),
	name: r.string().register(r.globalRegistry, { description: "Custom sales channel name." }),
	shopId: r.string().register(r.globalRegistry, { description: "Owning shop ID for the sales channel." }),
	url: r.url().max(250).register(r.globalRegistry, { description: "The URL of the sales channel." })
}), Z = r.object({
	type: r.union([r.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]), r.string()]).register(r.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: r.union([
		r.literal(400),
		r.literal(401),
		r.literal(404),
		r.literal(415),
		r.literal(500)
	]).register(r.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: r.string().register(r.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: r.string().register(r.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: r.url().register(r.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: r.unknown().register(r.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}), xe = Z.and(r.object({
	type: r.union([r.enum(["urn:problem:client"]), r.string()]).register(r.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: r.literal(400).register(r.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: r.array(r.object({
		detail: r.string(),
		pointer: r.string().register(r.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).register(r.globalRegistry, { description: "Detailed information regarding the violations." })
})), Se = Z.and(r.object({
	type: r.union([r.enum(["urn:problem:server"]), r.string()]).register(r.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: r.literal(500).register(r.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional()
}));
Z.and(r.object({
	type: r.union([r.enum(["urn:problem:invalid-request-syntax"]), r.string()]).register(r.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: r.literal(400).register(r.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: r.array(r.object({
		detail: r.string(),
		pointer: r.string().register(r.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).register(r.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), Z.and(r.object({
	type: r.union([r.enum(["urn:problem:not-found"]), r.string()]).register(r.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: r.literal(404).register(r.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional()
})), r.object({
	body: r.array(r.union([ye, be])).register(r.globalRegistry, { description: "Body for ingesting orders." }),
	path: r.never().optional(),
	query: r.never().optional()
});
var Ce = r.array(r.union([
	r.object({ status: r.literal(202) }),
	xe,
	Se
])).register(r.globalRegistry, { description: "The result per item." });
r.object({
	body: r.never().optional(),
	path: r.never().optional(),
	query: r.object({ filter: r.object({ shopId: r.array(r.string().register(r.globalRegistry, { description: "The unique identifier of the shop." })).optional() }).optional() }).optional()
});
var we = r.object({ results: r.array(X) }).register(r.globalRegistry, { description: "Found sales channels." });
r.object({
	body: r.object({
		name: r.string().register(r.globalRegistry, { description: "The name of the sales channel." }),
		shopId: r.string().register(r.globalRegistry, { description: "The shop ID of the sales channel." }),
		url: r.url().max(250).register(r.globalRegistry, { description: "The URL of the sales channel." })
	}).register(r.globalRegistry, { description: "Body for creating a sales channel." }),
	path: r.never().optional(),
	query: r.never().optional()
});
var Te = X;
r.object({
	body: r.never().optional(),
	path: r.object({ salesChannelId: r.string().register(r.globalRegistry, { description: "The ID of the sales channel." }) }),
	query: r.never().optional()
});
var Ee = X;
r.object({
	body: r.object({ salesChannelId: r.string().register(r.globalRegistry, { description: "The ID of the sales channel." }) }).register(r.globalRegistry, { description: "Body for removing a sales channel." }),
	path: r.never().optional(),
	query: r.never().optional()
});
var De = r.void().register(r.globalRegistry, { description: "The sales channel has been removed." });
r.object({
	body: r.object({
		name: r.string().register(r.globalRegistry, { description: "The name of the sales channel." }),
		salesChannelId: r.string().register(r.globalRegistry, { description: "The ID of the sales channel." })
	}).register(r.globalRegistry, { description: "Body for renaming a sales channel." }),
	path: r.never().optional(),
	query: r.never().optional()
});
var Oe = X, Q = (e) => (e.client ?? C).post({
	requestValidator: async (e) => await z.parseAsync(e),
	responseValidator: async (e) => await Ce.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/orders",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), ke = (e) => (e?.client ?? C).get({
	requestValidator: async (e) => await B.parseAsync(e),
	responseValidator: async (e) => await we.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/sales-channels",
	...e
}), Ae = (e) => (e.client ?? C).post({
	requestValidator: async (e) => await V.parseAsync(e),
	responseValidator: async (e) => await Te.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/sales-channels",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), je = (e) => (e.client ?? C).get({
	requestValidator: async (e) => await U.parseAsync(e),
	responseValidator: async (e) => await Ee.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/sales-channels/{salesChannelId}",
	...e
}), Me = (e) => (e.client ?? C).post({
	requestValidator: async (e) => await W.parseAsync(e),
	responseValidator: async (e) => await De.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/remove-sales-channel",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ne = (e) => (e.client ?? C).post({
	requestValidator: async (e) => await G.parseAsync(e),
	responseValidator: async (e) => await Oe.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/rename-sales-channel",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
});
//#endregion
//#region ../../node_modules/.pnpm/es-toolkit@1.51.0/node_modules/es-toolkit/dist/util/attemptAsync.mjs
async function Pe(e) {
	try {
		return [null, await e()];
	} catch (e) {
		return [e, null];
	}
}
//#endregion
//#region src/utils/throwErrorMessage.ts
/* c8 ignore start */
var Fe = (e) => {
	if (e instanceof i) throw Error(e.issues[0]?.message ?? e.message);
	if (typeof e == "object" && e && "status" in e && typeof e.status == "number") {
		let t = e.status;
		if (t === n.Unauthorized) throw Error("Unauthorized");
		if (t === n.NotFound && "detail" in e) throw Error(String(e.detail));
		if (t === n.BadRequest) {
			let t = e;
			if (t.errors && t.errors.length > 0) throw Error(t.errors[0].detail);
		}
		let { detail: r, title: i } = e;
		if (r || i) throw Error(r ?? i);
	}
	throw Error(String(e));
}, Ie = () => C.getConfig().auth, $ = (n = { token: void 0 }) => {
	if (!n.token) throw Error("Token is required");
	let r = {
		baseUrl: e,
		auth: n.token
	};
	return n.environment && n.environment === "acceptance" && (r.baseUrl = t), n.locale && (r.headers = {
		...r.headers,
		"Accept-Language": n.locale
	}), C.setConfig(r), n.token;
}, Le = (e) => {
	C.setConfig({ headers: {
		...C.getConfig().headers,
		"Accept-Language": e
	} });
}, Re = async (e) => {
	let [t, n] = await Pe(() => Q({ body: e }));
	return t || !n ? Fe(t) : n.data;
};
function ze() {
	return {
		postOrders: Re,
		getToken: Ie,
		initClient: $,
		setAcceptLanguageHeader: Le
	};
}
//#endregion
export { A, V as C, R as D, L as E, k as F, P as I, C as L, N as M, j as N, ce as O, D as P, me as S, I as T, z as _, Me as a, pe as b, w as c, U as d, fe as f, T as g, E as h, Q as i, F as j, le as k, M as l, de as m, ke as n, Ne as o, B as p, je as r, Ae as s, ze as t, O as u, ue as v, H as w, G as x, W as y };
